import { render, staticRenderFns } from "./entrega.vue?vue&type=template&id=65f29807&"
import script from "./entrega.vue?vue&type=script&lang=js&"
export * from "./entrega.vue?vue&type=script&lang=js&"
import style0 from "./entrega.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports